import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Api from './views/api.vue';
import About from './views/about.vue';
import Embeded from './views/embeded.vue';
import NotFound from './views/404.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/api',
      name: 'api',
      component: Api,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/embeded/:numberWord',
      name: 'embed',
      component: Embeded,
    },
    { 
      path: '/404', 
      name: 'notfound',
      component: NotFound },  
    { 
      path: '*', 
      redirect: '/404', 
    },  
  ],
});
